import { useTranslation } from "react-i18next";
import { formatPrice } from "../../utils/functions";
import { purchasePackageAPI } from "../../api/package";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import useToast from "../../hooks/useToast";
import { useState } from "react";

const BuyGame = ({ isOpen, onClose, game }) => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();

  const HandleRedirectToPayment = ({ sessionId }: { sessionId: string }) => {
    (window as any)?.Checkout?.configure({
      session: {
        id: sessionId, // ✅ must be object
      },
    });

    (window as any)?.Checkout?.showPaymentPage(); // or Checkout.showLightbox();
  }

  const [isLoading, setIsLoading] = useState(false);
  const { mutate: purchasePackage } = useMutation({
    mutationFn: purchasePackageAPI,
    onSuccess: (data) => {
      setIsLoading(true);
      if (data?.data?.sessionId) {
        HandleRedirectToPayment({ sessionId: data?.data?.sessionId });
      } else {
        useToast(data.data.message, "error");
      }
      //   {
      //     "status": true,
      //     "message": "Payment initiated successfully",
      //     "data": {
      //         "sessionId": "SESSION0002417648718K01288491E1",
      //         "orderId": "ORDER-1769698520737-17F523H",
      //         "merchant": "40021646",
      //         "result": "SUCCESS",
      //         "session": {
      //             "id": "SESSION0002417648718K01288491E1",
      //             "updateStatus": "SUCCESS",
      //             "version": "5152d20a01"
      //         },
      //         "successIndicator": "b14a96e980da4d40"
      //     }
      // }


      // onClose();
      // useToast(data.data.message, "success");
      // navigate("/purchase-history");
    },
    onError: (error: any) => {
      useToast(error.message, "error");
      setIsLoading(false);
    },
  });


  const handleBuyGame = () => {
    setIsLoading(true);
    purchasePackage({ package_id: game?.id, payment_method: "card", device_type: "web" });
  };

  if (!isOpen || !game) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
        {/* Modal Content */}
        <div className="modal bg-white-500 lg:rounded-[1.5vw] rounded-3xl 2xl:p-[2vw] md:p-8 p-6 2xl:max-w-[35vw] md:max-w-[600px] max-w-[90%] w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary auth-page overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)] hide-scroll">
          <div className="flex lg:gap-[1vw] gap-2 items-start justify-between w-full lg:mb-[1vw] mb-3">
            <h1 className="2xl:text-[1.563vw]/[1.7vw] xl:text-3xl/tight text-2xl/6 font-semibold text-primary-orange">
              {t("packageList.buyGame")}
            </h1>
            {/* Close Button */}
            <button
              onClick={onClose}
              className="lg:w-[1.2vw] lg:h-[1.2vw] md:w-5 w-4 md:h-5 h-4 flex items-center justify-center cursor-pointer ms-auto hover:scale-110 transition-transform duration-300 outline-none"
            >
              <svg
                className="w-full h-full"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9474 12.1123C15.8856 12.0504 15.8856 11.9496 15.9474 11.8878L23.5029 4.3286C24.149 3.68231 24.149 2.63063 23.5029 1.98429L22.0051 0.48573C21.692 0.172468 21.2758 0 20.833 0C20.3902 0 19.9739 0.172468 19.6609 0.485683L12.1054 8.04493C12.0672 8.08316 12.0235 8.09122 11.9937 8.09122C11.9639 8.09122 11.9203 8.08321 11.8821 8.04493L4.32658 0.485683C4.01351 0.172468 3.59726 0 3.15445 0C2.71164 0 2.29544 0.172468 1.98236 0.485683L0.484547 1.98429C-0.161516 2.63063 -0.161516 3.68231 0.484547 4.3286L8.04001 11.8878C8.10185 11.9496 8.10185 12.0504 8.04001 12.1123L0.484547 19.6714C-0.161469 20.3178 -0.161469 21.3694 0.484547 22.0157L1.98236 23.5143C2.29544 23.8275 2.71168 24 3.15445 24C3.59721 24 4.01351 23.8275 4.32658 23.5143L11.882 15.9551C11.9203 15.9169 11.9638 15.9089 11.9937 15.9089C12.0235 15.9089 12.0671 15.9169 12.1053 15.9552L19.6608 23.5143C19.9739 23.8276 20.3901 24 20.8329 24C21.2758 24 21.692 23.8276 22.005 23.5143L23.5028 22.0158C24.1489 21.3695 24.1489 20.3178 23.5028 19.6715L15.9474 12.1123Z"
                  fill="#333938"
                />
              </svg>
            </button>
          </div>

          {/* Divider */}
          <div className="text-center lg:mb-[1.042vw] md:mb-6 mb-4 landscape:max-lg:mb-4">
            <hr className="border-0 2xl:h-[0.053vw] h-px w-full 2xl:mb-[1vw] md:mb-4 mb-3 2xl:mt-[0.5vw] mt-2 [background:linear-gradient(90deg,rgba(11,51,105,0)_0%,#7364FF_50%,rgba(11,51,105,0)_100%)]" />
            <p className="2xl:text-[1.563vw]/[1.7vw] xl:text-3xl/tight text-2xl/6 font-semibold text-black-300/80">
              {game?.name?.[currentLanguage as keyof typeof game.name]}
            </p>
          </div>

          {/* Game Details */}
          <div className="lg:space-y-[0.833vw] space-y-4 lg:mb-[1.042vw] md:mb-6 mb-4">
            {/* Description */}
            <div className="lg:rounded-[0.833vw] rounded-2xl">
              <h3 className="2xl:text-[1.12vw]/tight text-lg/tight font-bold text-black-300 lg:mb-[0.313vw] mb-1.5">
                {t("packageList.aboutThisPackage")}
              </h3>
              <p className="2xl:text-[0.84vw]/[1vw] md:text-base/tight text-sm/tight landscape:max-lg:text-sm/tight text-black-800 font-bold">
                {game?.description?.[currentLanguage as keyof typeof game.description]}
              </p>
            </div>

            {/* Features */}
            {/* <div className="2xl:pb-[0.3vw] md:pb-3 lg:rounded-[0.833vw] rounded-2xl">
              <h3 className="2xl:text-[1.12vw]/tight text-lg/tight font-bold text-black-300 lg:mb-[0.313vw] mb-1.5">
                Features:
              </h3>
              <ul className="2xl:space-y-[0.208vw] space-y-2 grid md:grid-cols-2 grid-cols-1 2xl:gap-[0.4vw] gap-3 gap-y-0">
                {game?.features?.[currentLanguage as keyof typeof game.features]?.map((feature, index) => (
                  <li
                    key={index}
                    className="flex items-start lg:gap-[0.208vw] gap-2 text-gray-700 2xl:text-[0.938vw]/tight text-base/tight"
                  >
                    <svg
                      className="lg:w-[1.042vw] lg:h-[1.042vw] w-5 h-5 text-primary-orange lg:mt-[0.104vw] mt-0.5 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div> */}

            {/* Players & Duration */}
            <div className="grid grid-cols-1 lg:gap-[0.833vw] md:gap-4 gap-3 ">
              <div className="lg:border-[0.2vw] border-3 border-transparent bg-primary-ivory lg:p-[0.833vw] md:p-4 p-3 lg:rounded-[0.833vw] rounded-2xl text-center">
                <p className="2xl:text-[0.84vw]/[1vw] text-base/tight text-black-800 text-center font-bold lg:mb-[0.3vw] mb-1">
                  {t("packageList.games")}
                </p>
                <p className="2xl:text-[1.12vw]/tight text-lg/tight font-bold text-black-300">
                  {
                    game?.games_count === 1 ? t("packageList.oneGame") : `${game?.games_count} ${t("packageList.games")}`
                  }
                </p>
              </div>
              <div className="lg:border-[0.2vw] border-3 border-transparent bg-primary-ivory lg:p-[0.833vw] md:p-4 p-3 lg:rounded-[0.833vw] rounded-2xl text-center">
                <p className="2xl:text-[0.84vw]/[1vw] text-base/tight text-black-800 font-bold lg:mb-[0.3vw] mb-1">
                  {t("packageList.price")}
                </p>
                <p className="2xl:text-[1.12vw]/tight text-lg/tight font-bold text-black-300">
                  {game?.display_price ?? (game?.price != null ? formatPrice(game.price) : "0.0")} BHD
                </p>
              </div>
              {/* <div className="lg:border-[0.2vw] border-3 border-transparent bg-primary-ivory lg:p-[0.833vw] md:p-4 p-3 lg:rounded-[0.833vw] rounded-2xl text-center">
                <p className="text-gray-700 2xl:text-[0.938vw]/tight text-base/tight lg:mb-[0.3vw] mb-1">Price</p>
                <p className="2xl:text-[1.12vw]/tight text-lg/tight font-bold text-black-300">{game?.price}</p>
              </div> */}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex sm:flex-row flex-col lg:gap-[0.625vw] sm:gap-3 gap-2">
            <button
              onClick={onClose}
              className="flex-1 w-full 2xl:rounded-[0.26vw] rounded-[5px] h-full flex skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] lg:text-[1.1vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-black-300 bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]"
            >
              <span className="2xl:pt-[0.7vw] pt-2.5 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.5vw] py-2 lg:px-[5%] px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-white w-full h-full">
                <span className="skew-x-[10deg] block">{t("packageList.cancelButton")}</span>
              </span>
            </button>
            <button
              onClick={handleBuyGame}
              disabled={isLoading}
              className="flex-1 w-full 2xl:rounded-[0.26vw] rounded-[5px] h-full flex skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] lg:text-[1.1vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-primary-yellow bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center disabled:opacity-50 disabled:cursor-not-allowed 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]"
            >
              <span className="2xl:pt-[0.7vw] pt-2.5 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.5vw] py-2 lg:px-[5%] px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-[linear-gradient(180deg,#D76A4D_0%,#B35840_101.89%)] w-full h-full">
                <span className="skew-x-[10deg] block">
                  {isLoading ? (
                    <span className="inline-flex items-center justify-center gap-2">
                      <span className="w-5 h-5 border-2 border-black-300 border-t-transparent rounded-full animate-spin" />
                      <span>{t("packageList.purchase")}</span>
                    </span>
                  ) : (
                    t("packageList.purchase")
                  )}
                </span>
              </span>
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default BuyGame;
